module.exports = __webpack_public_path__ + "img/partner-1.5e143edf.png";